<template>
  <svg :width="width" :height="height" :class="className" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
    <path :fill="color" d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/>
  </svg>
</template>

<script>
export default {
  name: "IconArrowLeft",
  props: {
    className: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#0a2336'
    },
    width: {
      type: String,
      default: '1.2em'
    },
    height: {
      type: String,
      default: '1.2em'
    },
  },
}
</script>